export default __webpack_public_path__ + "static/media/icons.600796d0.jpeg";